<template>
  <div>
    <div class="table">
      <el-form :model="form" label-width="120px" ref="ruleForm">
        <el-form-item label="案例标签" prop="title">
          <el-select v-model="editData.label" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in options" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其它标签">
          <el-input type="text" placeholder="请输入标签名称" v-model="editData.labelMore">
          </el-input>
          <div class="msg">
            <p>注：多个用;分隔</p>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-Btn">
        <el-button size="small" @click="closedialog">取消</el-button>
        <el-button size="small" type="primary" @click="updateData">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addClassicCase } from "@/api/case.js";

export default {
  name: 'title_ecit',
  props: {
    closedialog: {
      type: Function,
      default: () => { }
    },
    caseIndex: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      form: {},
      saveData: {},
      editData: {},
      options: ['测绘服务', '数据服务', '数智应用'],
    }
  },
  mounted () {
    this.editData = JSON.parse(JSON.stringify(this.$store.state.pageTemplateData))
    this.saveData = this.$store.state.pageTemplateData
  },
  methods: {
    updateData () {
      this.saveData = this.editData
      addClassicCase(this.saveData).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.closedialog()
          this.$store.commit('changeRefresh')
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },
  }
}

</script>
<style  lang="scss" scoped>
.dialog-Btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>